import { IResponse } from '@signal/asp-data-commons';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {countryCd, environment} from './util.service';
import {Store} from '@ngrx/store';
import {DealerState} from '../../store/dealer/dealer.reducer';
import {selectDealerCode} from '../../store/dealer/dealer.selectors';

@Injectable({
    providedIn: 'root'
})
export class MileageService {
    private apiRoot: string;

  constructor(private readonly http: HttpClient,
              private readonly dealerState: Store<DealerState>) {
    this.apiRoot = environment.aspCatalogApi;
    }

    getMileages(): Observable<IResponse<number[]>> {
      const countryAbbr= countryCd.toUpperCase() === 'USA' ? 'US' : 'MX';
      return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
        return this.http.get(`${this.apiRoot}service-opcode/${dealerCode}/mileages?countryCode=${countryAbbr}`).pipe(
            map((data: IResponse<number[]>) => {
                return data;
            })
        )
      }));
    }

}
